import { Component, OnInit ,Input} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';

@Component({
  selector: 'app-submit-validations',
  templateUrl: './submit-validations.component.html',
  styleUrls: ['./submit-validations.component.scss']
})
export class SubmitValidationsComponent implements OnInit {
  @Input() public Content: any;
  content :any;
  lstMsgs:any=[];
  ChangeLog:any=[];
  action: Subject<any> = new Subject();
  constructor( public modalRef: NgbActiveModal,private commonService:CommonService,
    public summaryService:IstSummaryService) { }

  ngOnInit(): void {
this.lstMsgs=this.Content.content.SubmitValidationMsg;
this.ChangeLog=this.Content.content.ChangeLog;
  }
  CancelClick(): void {
    this.modalRef.close('cancel');
    this.action.next('cancel');
  }

  OkClick()
  {
    this.summaryService.getAppSubmitValidations("api/ISTGeneralInfo/IST_APPSubmitChangeLog?ApplicationID=" +this.Content.content.ApplicationID+"&submodule="+this.Content.content.SubModuleID).subscribe((result) => {
      this.modalRef.dismiss();
      this.commonService.refreshApplicationPage(this.Content.content.ApplicationID,this.Content.content.ModuleID,"");
    });
  }
}
